<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">

                <gj-market-select
                        v-model="filter.marketIds"
                        multiple
                        width="170px"
                        placeholder="请选择店铺"
                ></gj-market-select>

                <gj-date-picker
                        type="daterange"
                        v-model="filter.date"/>
                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'msku', text: 'MSKU'},
                       {id: 'asin', text: 'ASIN'},
                       {id: 'fnsku', text: 'FNSKU'}
                   ]"
                >
                </gj-select-input>

                <gj-category-select
                        v-model="filter.categoryIds"
                        placeholder="品类"
                        multiple
                        active
                ></gj-category-select>

                <gj-brand-select
                        v-model="filter.brandIds"
                        placeholder="品牌"
                        multiple
                        collapse-tags
                        active
                ></gj-brand-select>

                <template #right>
                    <gj-tool-group
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('longStorageFee:export')"
                            download-url="/operation/longStorageFee/export"
                            :download-params="globalParams"
                            help
                    >
                    </gj-tool-group>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
              <template v-slot:asin="{row}">
                <el-row>
                  <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
                </el-row>
              </template>
                <template v-slot:sku="{row}">
                    <gj-tooltip :text-line="1" :content="row.skuName">
                        {{row.skuName | defaultShow}}
                    </gj-tooltip>
                    <el-row>
                        <el-col :span="24">
                            <div class="text-ellipsis-1">{{row.sku | defaultShow}}<gj-copy-icon v-if="isMeaningful(row.sku)" :content="row.sku"/></div>
                        </el-col>
                    </el-row>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {queryMixin, isMeaningfulMixin} from "../../../../minxins";
    import {isMeaningful} from "../../../../utils/common";
    import {exportLongStorageFee, getLongStorageFeePage} from "../../../../api/statistics";
    import {convertToDate} from "../../../../utils/date.util";

    export default {
        name: "app-longStorageFee",
        mixins: [queryMixin, isMeaningfulMixin],
        components: {
        },
        data() {
            return {
                tableName: 'longStorageFee',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    {id: 'marketName', header: '店铺/国家', field: 'marketName', minWidth: '120px', default: true, fixed: 'left', disabled: true},
                    {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true, fixed: 'left', disabled: true},
                    {id: 'asin', header: 'ASIN', field: 'slot:asin', fixed: 'left', minWidth: '140px', default: true, sortable: true,disabled: true},
                    {id: 'msku', header: 'MSKU', field: 'msku', fixed: 'left', minWidth: '140px', default: true, sortable: true,disabled: true, copyable:true},
                    {id: 'productName', header: '商品标题', field: 'productName',fixed: 'left',  minWidth: '150px', default: true, overflowLine: 1, disabled: true},
                    {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '185px', default: true, sortable: true},
                    {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '100px', default: true, sortable: true},
                    {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '100px', default: true},
                    {id: 'brandName', header: '品牌', field: 'brandName', minWidth: '100px', default: true},
                    {id: 'snapshotDate', header: '时间', field: 'snapshotDate', minWidth: '180px', default: true},
                    {id: 'condition', header: '状况', field: 'condition', minWidth: '100px', default: true},
                    {id: 'currency', header: '币种', field: 'currency', minWidth: '80px', align: 'right', default: true},
                    {id: 'quantity6More', header: '6-12个月收费商品数', field: 'quantity6More', minWidth: '160px', sortable: true, sortBy: 'quantity_6More', align: 'right', default: true},
                    {id: 'storageFee6More', header: '6-12个月收费', field: 'storageFee6More', minWidth: '140px', sortable: true, sortBy: 'storageFee_6More', align: 'right', default: true},
                    {id: 'quantity12More', header: '12个月以上收费商品数', field: 'quantity12More', minWidth: '170px', sortable: true, sortBy: 'quantity_12More', align: 'right', default: true},
                    {id: 'storageFee12More', header: '12个月以上收费', field: 'storageFee12More', minWidth: '140px', sortable: true, sortBy: 'storageFee_12More', align: 'right', default: true},
                    {id: 'perUnitVolume', header: '单个体积', field: 'perUnitVolume', minWidth: '80px', align: 'right', default: true},
                    {id: 'volumeUnit', header: '体积单位', field: 'volumeUnit', minWidth: '90px', default: true},
                    {id: 'enrolledSmallAndLight', header: '是否注册轻小商品', field: 'enrolledSmallAndLight', minWidth: '160px', default: true}
                ],
                tableData: [],
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                filter: {
                    marketIds: [],
                    date: null,
                    keyword: {
                        key: 'msku', value: null
                    },
                    categoryIds: [],
                    brandIds: [],
                },
                cacheOptions: {
                    useCache: true,
                }
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            $gjQueryInitParams() {
                return {
                    filter: {
                        marketIds: [],
                        date: null,
                        
                        keyword: {
                            key: 'msku', value: null
                        },
                        categoryIds: [],
                        brandIds: []
                    }
                };
            },
            /**
             *
             * @param params 查询条件参数
             * @override queryMixin
             * @returns {{ marketIds: *}}
             */
            $gjCacheCallback(params) {
                return {
                    marketIds: params.marketIds,
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        marketIds: this.filter.marketIds,
                        categoryIds: this.filter.categoryIds,
                        brandIds: this.filter.brandIds,
                        startMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
                        endMarketTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                this.globalParams = params;
                // 查询
                this.loading = true;
                getLongStorageFeePage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
        },
    }
</script>

<style scoped>

</style>
